import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#BE3A34", d: "M0 0h5v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#046A38", d: "M0 0h5v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFB81C", d: "M0 0h5v1H0z" }));
const ForwardRef = forwardRef(SvgLt);
const Memo = memo(ForwardRef);
export default Memo;
